import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';
import { StockItem, StockJournal } from './stock-state/stock.model';

@Injectable({
  providedIn: 'root'
})
export class StockService {
  private _apiUrl = environment.apiUrl;
  private _httpClient = inject(HttpClient);


  getStockItems(): Observable<StockItem[]> {
    return this._httpClient.get<StockItem[]>(`${this._apiUrl}/v1/stock/get-all-stock`).pipe(
      map(stockItems =>
        stockItems.map(item => ({
          _id: item._id,
          type: item.type,
          shipmentReference: item.shipmentReference ?? null,
          pcNumber: item.pcNumber,
          journalReference: item.journalReference ?? null,

          warehouseHeadOffice: item.warehouseHeadOffice ?? null,
          country: item.country ?? null,
          displayInternalGrade: item.displayInternalGrade ?? null,


          internalGrade: item.stockInternalGrade ?? null,
          externalGrade: item.externalGrade ?? item.shippingMark ?? null,

          noOfCartons: item.noOfCartons ?? 0,
          cartonNettWeight: item.cartonNettWeight ?? 0,
          quantityKgs: item.quantityKgs ?? 0,

          createdAt: item.createdAt ? new Date(item.createdAt) : null,
          updatedAt: item.updatedAt ? new Date(item.updatedAt) : null,

          stockKey: item.stockKey ?? '',
          usdPerKg: item.usdPerKg ?? 0,
          usdValue: item.usdValue ?? 0,
          qtyIn: item.qtyIn ?? 0,
          qtyOut: item.qtyOut ?? 0,
          stockOnHand: item.stockOnHand ?? 0,
          reason: item.reason ?? '',

          parentId: item.parentId ?? null,
          purchaseConfirmationId: item.purchaseConfirmationId ?? null,
          documentReference: item.documentReference ?? null,
          internalGradeId: item.internalGradeId ?? null,
          salesConfirmationNumber: item.salesConfirmationNumber ?? null,
        }))
      )
    );
  }



  getStockJournals(): Observable<StockJournal[]> {
    return this._httpClient.get<StockJournal[]>(`${this._apiUrl}/v1/stock/get-all-stock-journals`);
  }


  createStockJournal(stockJournal: Partial<StockJournal>): Observable<StockJournal> {
    return this._httpClient.post<StockJournal>(`${this._apiUrl}/v1/stock/create-stock-journal`, stockJournal);
  }


  getStockJournalById(id: string): Observable<StockJournal> {
    return this._httpClient.get<StockJournal>(`${this._apiUrl}/v1/stock/get-stock-journal/${id}`);
  }


  updateStockJournal(id: string, stockJournal: Partial<StockJournal>): Observable<StockJournal> {
    return this._httpClient.put<StockJournal>(`${this._apiUrl}/v1/stock/update-stock-journal/${id}`, stockJournal);
  }


  deleteStockJournal(id: string): Observable<any> {
    return this._httpClient.delete(`${this._apiUrl}/v1/stock/delete-stock-journal/${id}`);
  }

  getInternalGrades(): Observable<string[]> {
    return this._httpClient.get<string[]>(`${this._apiUrl}/v1/stock/get-internal-grades`);
  }

  onValidateStock(purchaseConfirmationId: string, stockId: string): Observable<any> {
    return this._httpClient.get<any>(`${this._apiUrl}/v1/stock/validate-stock/${purchaseConfirmationId}/${stockId}`);
  }

}
